import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'lil-gui'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry'
import gsap from 'gsap'

/**
 * Base
 */
// Debug
// const gui = new dat.GUI()

// Fonts
// const fontLoader = new FontLoader()
// fontLoader.load(
//     '/fonts/helvetiker_regular.typeface.json',
//     (font) =>
//     {
//         const textGeometry = new TextGeometry(
//             'Hello World!',
//             {
//                 font,
//                 size: 0.5,
//                 height: 0.2,
//                 curveSegments: 5,
//                 bevelEnabled: true,
//                 bevelThickness: 0.03,
//                 bevelSize: 0.02,
//                 bevelOffset: 0,
//                 bevelSegments: 4
//             }
//         )
//         // textGeometry.computeBoundingBox()
//         // textGeometry.translate(
//         //     - (textGeometry.boundingBox.max.x - 0.02) * 0.5,
//         //     - (textGeometry.boundingBox.max.y - 0.02) * 0.5,
//         //     - (textGeometry.boundingBox.max.z - 0.03) * 0.5
//         // )
//         // Equivalent calculations
//         textGeometry.center()

//         // const material = new THREE.MeshMatcapMaterial({ matcap: matcapTexture })
//         // const text = new THREE.Mesh(textGeometry, material)
//         // scene.add(text)

//         const donutGeometry = new THREE.TorusGeometry(0.3, 0.2, 20, 45)
//         const sphereGeometry = new THREE.SphereGeometry(0.5, 15, 15)

//         // console.time('donuts')
//         // for(let i = 0; i < 100; i++) {
//         //     const donut = new THREE.Mesh(donutGeometry, material)
//         //     const sphere = new THREE.Mesh(sphereGeometry, material)
            
//         //     donut.position.x = (Math.random() - 0.5) * 10
//         //     donut.position.y = (Math.random() - 0.5) * 10
//         //     donut.position.z = (Math.random() - 0.5) * 10

//         //     donut.rotation.x = Math.random() * Math.PI
//         //     donut.rotation.y = Math.random() * Math.PI

//         //     const scale = Math.random()
//         //     donut.scale.set(scale, scale, scale)

//         //     scene.add(donut)

//         //     sphere.position.x = (Math.random() - 0.5) * 10
//         //     sphere.position.y = (Math.random() - 0.5) * 10
//         //     sphere.position.z = (Math.random() - 0.5) * 10
//         //     sphere.scale.set(scale, scale, scale)

//         //     scene.add(sphere)
//         // }
//         // console.timeEnd('donuts')
//     }
// )

// Lower bevel and curve Segments to make it easier for computer to compute

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

// Axes
// const axesHelper = new THREE.AxesHelper()
// scene.add(axesHelper)

/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader()
const blueTexture = textureLoader.load('/textures/matcaps/blue-2.png')
const pinkTexture = textureLoader.load('/textures/matcaps/pink-4.png')
const redTexture = textureLoader.load('/textures/matcaps/red-3.png')
const greenTexture = textureLoader.load('/textures/matcaps/green-2.png')
const goldTexture = textureLoader.load('/textures/matcaps/yellow.png')
const normalyTexture = textureLoader.load('/textures/matcaps/normaly.png')
// normalyTexture.generateMipmaps = false
// normalyTexture.minFilter = THREE.NearestFilter
const blueMaterial = new THREE.MeshMatcapMaterial({ matcap: blueTexture })
const pinkMaterial = new THREE.MeshMatcapMaterial({ matcap: pinkTexture })
const redMaterial = new THREE.MeshMatcapMaterial({ matcap: redTexture })
const greenMaterial = new THREE.MeshMatcapMaterial({ matcap: greenTexture })
// const normalyMaterial = new THREE.MeshMatcapMaterial({ matcap: normalyTexture })
const normalyMaterial = new THREE.MeshNormalMaterial()
const goldMaterial = new THREE.MeshMatcapMaterial({ matcap: goldTexture })


// Shapes
const twoPi = Math.PI * 2

const circleData = {
    radius: 0.5,
    tube: 0.1,
    radialSegments: 20,
    tubularSegments: 100,
    arc: twoPi
};

const squareData = {
    radius: 0.5,
    tube: 0.1,
    radialSegments: 20,
    tubularSegments: 4,
    arc: twoPi
};

const triangleData = {
    radius: 0.5,
    tube: 0.1,
    radialSegments: 20,
    tubularSegments: 3,
    arc: twoPi
};

const circleGeometry = new THREE.TorusGeometry(...Object.values(circleData))
const squareGeometry = new THREE.TorusGeometry(...Object.values(squareData))
const triangleGeometry = new THREE.TorusGeometry(...Object.values(triangleData))

function getRandomArbitrary(min, max) {
    return Math.random() * (max - min) + min;
}

/**
 * Fonts 
 */
const loader = new FontLoader()
let meshText;
loader.load(
    'fonts/optimer_regular.typeface.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            `
            play,
              laugh!
                learn :)
            `,
            {
                font,
                size: 0.3,
                height: 0.10,
                curveSegments: 20,
                bevelEnabled: true,
                bevelThickness: 0.03,
                bevelSize: 0.02,
                bevelOffset: 0,
                bevelSegments: 20
            }
        )
        textGeometry.center()

        meshText = new THREE.Mesh(textGeometry, goldMaterial)
        scene.add(meshText)
    }
)

// Load the 'x'
loader.load(
    '/fonts/helvetiker_regular.typeface.json',
    (font) =>
    {
        const scale = getRandomArbitrary(0.4, 1)
        for (let i = 1; i < 200; i++) 
        {
            const textGeometry = new TextGeometry(
                'x',
                {
                    font,
                    size: 0.8,
                    height: 0.07,
                    curveSegments: 5,
                    bevelEnabled: true,
                    bevelThickness: 0.03,
                    bevelSize: 0.02,
                    bevelOffset: 0,
                    bevelSegments: 5
                }
            )

            const meshText = new THREE.Mesh(textGeometry, blueMaterial)
            const randomDistText = getRandomArbitrary(25, 50)
            meshText.position.x = (Math.random() - 0.5) * randomDistText
            meshText.position.y = (Math.random() - 0.5) * randomDistText
            meshText.position.z = (Math.random() - 0.5) * randomDistText

            meshText.rotation.x = Math.random() * Math.PI
            meshText.rotation.y = Math.random() * Math.PI

            meshText.scale.set(scale, scale, scale)
            scene.add(meshText)
        }

    }
)

// Load shapes
for (let i = 1; i < 200; i++) {
    const scale = getRandomArbitrary(0.4, 1)

    const meshCircle = new THREE.Mesh(circleGeometry, redMaterial)
    const randomDistCircle = getRandomArbitrary(25, 50)
    meshCircle.position.x = (Math.random() - 0.5) * randomDistCircle
    meshCircle.position.y = (Math.random() - 0.5) * randomDistCircle
    meshCircle.position.z = (Math.random() - 0.5) * randomDistCircle

    meshCircle.rotation.x = Math.random() * Math.PI
    meshCircle.rotation.y = Math.random() * Math.PI

    meshCircle.scale.set(scale, scale, scale)
    scene.add(meshCircle)

    const meshSquare = new THREE.Mesh(squareGeometry, pinkMaterial)
    const randomDistSquare = getRandomArbitrary(25, 50)
    meshSquare.position.x = (Math.random() - 0.5) * randomDistSquare
    meshSquare.position.y = (Math.random() - 0.5) * randomDistSquare
    meshSquare.position.z = (Math.random() - 0.5) * randomDistSquare

    meshSquare.rotation.x = Math.random() * Math.PI
    meshSquare.rotation.y = Math.random() * Math.PI

    meshSquare.scale.set(scale, scale, scale)
    scene.add(meshSquare)

    const meshTriangle = new THREE.Mesh(triangleGeometry, greenMaterial)
    const randomDistTriangle = getRandomArbitrary(25, 50)
    meshTriangle.position.x = (Math.random() - 0.5) * randomDistTriangle
    meshTriangle.position.y = (Math.random() - 0.5) * randomDistTriangle
    meshTriangle.position.z = (Math.random() - 0.5) * randomDistTriangle

    meshTriangle.rotation.x = Math.random() * Math.PI
    meshTriangle.rotation.y = Math.random() * Math.PI

    meshTriangle.scale.set(scale, scale, scale)
    scene.add(meshTriangle)
}

// // Debug 

// const meshCircle = new THREE.Mesh(circleGeometry, material)
// scene.add(meshCircle)

// function updateGeometry(mesh, geometry) {
//     mesh.geometry.dispose()
//     mesh.geometry = geometry;
// }

// function generateGeometry() {
//     updateGeometry(meshCircle, new THREE.TorusGeometry(
//         data.radius,
//         data.tube,
//         data.radialSegments,
//         data.tubularSegments,
//         data.arc
//     ))
// }
// gui.add(data, 'radius', 0.1, 20, 0.01).onChange(generateGeometry)
// gui.add(data, 'tube', 0.1, 10, 0.01).onChange(generateGeometry)
// gui.add(data, 'radialSegments', 2, 200).step(1).onChange(generateGeometry)
// gui.add(data, 'tubularSegments', 3, 100).step(1).onChange(generateGeometry)
// gui.add(data, 'arc', 0.1, twoPi).step(1).onChange(generateGeometry)



/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 100
camera.position.y = -100
camera.position.z = 2.5
// camera.position.x = -30
// camera.position.y = -30
// camera.position.z = -30
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
// Pre-intro controls
controls.enabled = false
controls.enableDamping = true
controls.minDistance = 1.5
// controls.autoRotate = true
// controls.autoRotateSpeed = 1.5

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(window.devicePixelRatio)
renderer.setClearColor(0x000000, 0)

/**
 * Animate
 */
let isIntroCameraDone = false
const introDuration = 3

// NOTE: xCameraEnd should be between -1 to 1, otherwise
// Math.asin() will be NaN. And the camera.x position will
// not be calculated properly.
const xCameraEnd = 0.3
const yCameraEnd = 0.5
gsap.to(
    camera.position,
    { 
        duration: introDuration,
        ease: 'sine.out',
        x: xCameraEnd,
        y: yCameraEnd,
        onComplete: () => isIntroCameraDone = true
    }
)

const clock = new THREE.Clock()
const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // NOTE: Calculations for janky floaty camera
    // let timeAfterIntro = elapsedTime - introDuration
    if (isIntroCameraDone) {
        // NOTE: Janky floaty camera
        // camera.position.x = Math.sin(Math.asin(xCameraEnd) + timeAfterIntro * 0.15)
        // camera.position.x = Math.cos(Math.acos(yCameraEnd) + timeAfterIntro * 0.15)

        controls.enabled = true 
        controls.autoRotate = true
        controls.autoRotateSpeed = 1.5
        controls.maxDistance = 15
    }

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()